import { api } from "@/api"

export type RetrieveTransactionReceiptData = {
  receipt: string
}

type RetrieveTransactionReceiptQuery = {
  isMerchant: boolean
}

export const retrieveTransactionReceipt = async (
  transactionId: string,
  query?: RetrieveTransactionReceiptQuery
) => {
  const { body } =
    await api.get<RetrieveTransactionReceiptData>(
      `/transactions/${transactionId}/receipt/`,
      { query }
    )
  return body
}
